import { useTranslation } from 'react-i18next'
import Link from 'src/components/navigation/link.component'
import { useCurrentProject } from 'src/providers/current-project.provider'
import { EVariableType } from 'src/types/variable'
import { type TChatbotNode } from '../node.type'
import { useChatbotFlow } from '../chatbot.provider'

function hasNodeDisplayedInDashboard(nodes: TChatbotNode[]): boolean {
  return nodes.some(({ data: { humanReviewCheck, variable } }) => {
    if (humanReviewCheck) return true
    if (variable?.type === EVariableType.BOOLEAN) {
      return (
        !!variable.condition?.yes?.requestHumanReviewProblem ||
        !!variable.condition?.no?.requestHumanReviewProblem
      )
    }
    if (variable?.type === EVariableType.INTEGER_VALUE_RANGE) {
      return !!variable.condition?.ranges.some((range) => range.action.requestHumanReviewProblem)
    }
    return false
  })
}

export function DashboardSubjectMissingBanner() {
  const { t } = useTranslation()
  const { project } = useCurrentProject()
  const { nodes, dashboardSubject, followupId, chatbotId } = useChatbotFlow()

  if (dashboardSubject || !hasNodeDisplayedInDashboard(nodes)) return null

  return (
    <div role="alert" className="c-mb-2 c-text-sm c-text-danger-600">
      {t('pages.configuration.followups.chatbot.node-form.dashboard-subject-missing')}{' '}
      <Link
        href={`/${project.id}/configuration/followups/${followupId}/chatbot/${chatbotId}/update-general-form`}
        className="c-font-semibold c-underline"
      >
        {t('pages.configuration.followups.chatbot.node-form.back-to-step-1')}
      </Link>
    </div>
  )
}
